import { useCallback, useEffect, useState } from "react";
import ShoppingCategoryService from "../services/ShoppingCategoryService";
import { ShoppingCategory } from "../models";

export default function useShoppingCategories() {
  const [shoppingCategories, setShoppingCategories] = useState<ShoppingCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const api = new ShoppingCategoryService();
      const data = await api.getShoppingCategories();
      setShoppingCategories(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load shopping categories");
      console.error("Error loading shopping categories:", err);
      setShoppingCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    shoppingCategories,
    loading,
    error,
    refetch: load,
  };
}
